import { render } from "./mRegarding.vue?vue&type=template&id=410ca298&scoped=true"
import script from "./mRegarding.vue?vue&type=script&lang=js"
export * from "./mRegarding.vue?vue&type=script&lang=js"

import "./mRegarding.vue?vue&type=style&index=0&id=410ca298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410ca298"]])

export default __exports__